import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#ACB8C3"
      d="M101.81 21.72a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M44.73 100.63a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      d="M9.77 73.38c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M57.01 86H33.09C30.28 86 28 83.73 28 80.92V25.08c0-2.8 2.28-5.08 5.09-5.08h36.07c1.35 0 2.64.53 3.6 1.49l9.75 9.72c.95.95 1.49 2.24 1.49 3.59v44.04c0 3.96-3.22 7.17-7.19 7.17h-19.8z"
    />
    <path
      fill="#7B8493"
      d="M71.4 35.18H39.37c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25H71.4c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M66.79 49.36H39.37c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h27.42c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M60.79 63.54H39.38c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h21.41c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M57.09 77.71H39.37c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h17.72c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#C7D0D9"
      d="M27.28 91.5h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V94.5h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M92.71 19.16l-3.94-3.94 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.59.58 1.54.59 2.12 0l3.94-3.94 3.94 3.94c.59.59 1.54.59 2.12 0s.59-1.54 0-2.12"
    />
    <path
      fill="#ACB8C3"
      d="M84 93c10.49 0 19-8.51 19-19s-8.51-19-19-19-19 8.51-19 19 8.51 19 19 19"
    />
    <path
      fill="#7B8493"
      d="M92.25 77.75c0-3.65-2.65-6-6.75-6h-3c-2.25 0-2.25-.98-2.25-1.5s0-1.5 2.25-1.5H89c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25h-2.75V64c0-1.24-1.01-2.25-2.25-2.25s-2.25 1.01-2.25 2.25v.28c-3.67.27-6 2.56-6 5.97 0 3.65 2.65 6 6.75 6h3c2.25 0 2.25.98 2.25 1.5s0 1.5-2.25 1.5H79c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h2.75V84c0 1.24 1.01 2.25 2.25 2.25s2.25-1.01 2.25-2.25v-.28c3.67-.27 6-2.56 6-5.97"
    />
  </svg>
);
const SvgEnrichedIconInvoiceGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconInvoiceGreyscale);
export default Memo;
